"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Toast_1 = __importDefault(require("react-bootstrap/Toast"));
var icon_library_enum_1 = __importDefault(require("../../shared/enums/icon-library.enum"));
var icon_enum_1 = __importDefault(require("../../shared/enums/icon.enum"));
var size_enum_1 = __importDefault(require("../../shared/enums/size.enum"));
var classMap_1 = __importDefault(require("../../shared/utilities/classMap"));
var action_1 = __importDefault(require("../action"));
var icon_1 = __importDefault(require("../icon"));
function Toast(props) {
    var _a, _b;
    var _c = react_1.default.useState(true), showToast = _c[0], setShowToast = _c[1];
    var handleClose = function (close) {
        if (props.handleClose) {
            return props.handleClose();
        }
        return setShowToast(close);
    };
    return (react_1.default.createElement(Toast_1.default, { show: props.show || showToast,
        delay: (_a = props.delay) !== null && _a !== void 0 ? _a : undefined,
        autohide: (_b = Boolean(props.delay)) !== null && _b !== void 0 ? _b : undefined,
        onClose: function () { return handleClose(false); },
        className: (0, classMap_1.default)("mpng-ux-toast", props.className, props.dark ? "bg-dark text-light" : "") },
        react_1.default.createElement("div", { className: "p-3 d-flex align-items-center" },
            props.headerIcon && (react_1.default.createElement("div", null,
                react_1.default.createElement(icon_1.default, { icon: props.headerIcon, library: icon_library_enum_1.default.REGULAR, size: size_enum_1.default.SMALL, squared: true, className: "d-inline-flex me-2" }))),
            props.header && (react_1.default.createElement("div", { className: (0, classMap_1.default)("toast-header", props.headerClassName, props.dismissible ? "me-auto" : "") }, props.header)),
            props.dismissible && (react_1.default.createElement("div", null,
                react_1.default.createElement(action_1.default, { callback: function () { return handleClose(false); },
                    className: (0, classMap_1.default)("p-0", props.dark ? "text-light" : "text-dark"),
                    icon: {
                        icon: icon_enum_1.default.TIMES,
                        library: icon_library_enum_1.default.LIGHT,
                        size: size_enum_1.default.SMALL,
                        squared: true,
                        className: "d-inline-flex"
                    },
                    priority: "link",
                    tabIndex: 0 })))),
        props.body && react_1.default.createElement("div", { className: props.hideBorders ? "p-3" : "border-top p-3" }, props.body)));
}
exports.default = Toast;
